const OFFERS_AMOUNT_ASK = 'OFFERS_AMOUNT_ASK';
const OFFERS_AMOUNT_RECEIVED = 'OFFERS_AMOUNT_RECEIVED';
const OFFERS_AMOUNT_FAILED = 'OFFERS_AMOUNT_FAILED';

const askForOffersAmount = () => ({
  type: OFFERS_AMOUNT_ASK
});

const offersAmountFailed = (message) => ({
  type: OFFERS_AMOUNT_FAILED,
  payload: {
    message
  }
});

const offersAmountReceived = (amount) => ({
  type: OFFERS_AMOUNT_RECEIVED,
  payload: {
    amount
  }
});

export {
  OFFERS_AMOUNT_ASK,
  OFFERS_AMOUNT_FAILED,
  OFFERS_AMOUNT_RECEIVED,
  askForOffersAmount,
  offersAmountFailed,
  offersAmountReceived
};
